module.exports = __webpack_public_path__ + "img/products-6.a6b2b8e6.jpg";